import { useQuery } from "@apollo/client";
import { useCallback, useMemo } from "react";
import { GET_SECURITY_ROLES } from "../graphql/auth-gql";
import { ISecurityRole, ISecurityRolesResponse } from "../types/auth";

export default function useSecurityRoles(): [
  ISecurityRole[],
  (id: number) => ISecurityRole | undefined
] {
  const { data } = useQuery<ISecurityRolesResponse>(GET_SECURITY_ROLES);

  const securityRoles = useMemo(() => (
    data?.securityRoles?.slice().sort((a, b) => a.desc.localeCompare(b.desc)) ?? []
  ), [data]);

  const getSecurityRole = useCallback((id: number) => (
    securityRoles.find(role => role.id === id)
  ), [securityRoles]);

  return [securityRoles, getSecurityRole];
}
